import { container, title } from "assets/jss/material-kit-react.js";

const landingPageStyle = {
  container: {
    zIndex: "12",
    color: "#FFFFFF",
    ...container
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "#FFFFFF",
    textDecoration: "none"
  },
  container2: {
    position: "absolute",
    width: "100%",
    zIndex: "1200",
    justifyContent: "center",
  },
  container3: {
    width: "100%",
    zIndex: "1200",
    alignItems: "center",
    justifyContent: "center"
  },
  title2: {
    ...title,
    flex: 1,
    minHeight: "32px",
    fontSize: "78px",
    color: "#FFFFFF",
    textDecoration: "none",
    textAlign: "center",
  },
  title3: {
    ...title,
    flex: 1,
    minHeight: "32px",
    fontSize: "32px",
    color: "#FFFFFF",
    marginTop: "-10px",
    textDecoration: "none",
    textAlign: "center",
  },
  logo: {
    width: "25%",
    height: "25%",
    display: "block",
    margin: "15px 0 !important",
    "&, & *": {
      letterSpacing: "normal !important"
    }
  },
  logo2: {
    width: "20%",
    height: "20%",
    marginLeft: "40%"
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0"
  },
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  }
};

export default landingPageStyle;
